import React from 'react';
import { Check } from 'lucide-react';

export default function ReadingAction({ question, onChoiceClick }) {
  return (
    <div className="flex flex-col items-center gap-8 w-full max-w-2xl">
      <h2 className="text-xl md:text-2xl font-semibold text-muted-foreground text-center min-h-[40px]">
        {question.ask}
      </h2>
      
      <div className="text-5xl md:text-6xl font-bold text-primary bg-white p-10 rounded-2xl border-2 border-border shadow-lg">
        {question.actionText}
      </div>

      <button 
        onClick={() => onChoiceClick('Ожидает оценки врача')} 
        className="mt-4 flex items-center gap-2 px-8 py-4 bg-green-500/20 text-green-600 border-2 border-green-500 rounded-2xl font-semibold hover:bg-green-500/30 transition-colors"
      >
        <Check className="size-6" /> Пациент выполнил
      </button>
    </div>
  );
}